export default {
  "memberDeposits.title": "Member Deposits",
  "memberDeposits.thead.index": "#NO",
  "memberDeposits.thead.orderno": "Deposit Order No",
  "memberDeposits.thead.merOrderno": "MerOrderno",
  "memberDeposits.thead.userno": "Member ID",
  "memberDeposits.thead.amount": "Deposit Amount",
  "memberDeposits.thead.platform": "Deposit Method",
  "memberDeposits.thead.deviceType": "Device Type",
  "memberDeposits.thead.depositStatus": "Deposit Status",
  "memberDeposits.thead.depositTime": "Deposit Time",
  "memberDeposits.thead.completeTime": "Complete Time",
  "memberDeposits.thead.action": "Action",
  "memberDeposits.copy.success": "Copy Success!",
  "memberDeposits.tooltip.copy.orderNo": "Copy Order No: {text}",
  "memberDeposits.tooltip.copy.merOrderNo": "Copy MerOrder No: {text}",
  "memberDeposits.tooltip.copy.userNo": "Copy User No: {text}",
  "memberDeposits.action.detail": "Detail",
};